import { Tooltip } from "@mui/material";
import moment from "moment";

import { DateField, useRecordContext } from "react-admin";

const utcDisplayOptions: Intl.DateTimeFormatOptions = { timeZone: "UTC" };

const LocalisedDateField = ({ record, field, compact = false, text = "", showTime = false, label = "" }: any) => {
  let sourceRecord = record || useRecordContext();
  let value = sourceRecord[field];
  if (!value) return "";

  return (
    <>
      {`${text} `}
      {!compact ? `${moment(value).fromNow()}: ` : ""}
      <Tooltip
        followCursor={true}
        arrow={true}
        title={
          <>
            <DateField
              record={sourceRecord}
              label={label}
              source={field}
              showTime={true}
            />
            <span style={{ fontSize: "14px" }}>{" in " + Intl.DateTimeFormat().resolvedOptions().timeZone}</span>
          </>
        }
      >
        <span className="local-time-tooltip-trigger">
          <DateField record={sourceRecord} source={field} showTime={showTime} options={utcDisplayOptions} />
          {!compact ? " UTC " : ""}
        </span>
      </Tooltip>
    </>
  );
};

export default LocalisedDateField;
